<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">เติมเครดิตเข้ากระเป๋า</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <b-table
                                ref="reportDelivery"
                                show-empty
                                responsive
                                :items="dataList"
                                :fields="fields"
                                :per-page="search.pageSize"
                                :busy="busy"
                                selectable
                                select-mode="multi"
                                class="scroll-bar-pop text-center"
                                empty-text="ไม่มีข้อมูลผู้ใช้"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                            >
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="totalItem"
                                    :current-page="search.pageIndex"
                                    :per-page="search.pageSize"
                                    :value="search.pageIndex"
                                    @input="changePage"
                                    align="right">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {queryCodInfo} from "@/api/cod";

export default {
    name: "",
    data() {
        return {
            totalItem: 0,
            search: {
                pageSize: 10,
                pageIndex: 1,
            },
            busy: false,
            dataList: [],
            fields: [
                {
                    key: 'credit',
                    label: 'จำนวนเครดิต',
                    sortable: true
                },
                {
                    key: 'price',
                    label: 'ราคา',
                    sortable: true
                },
                {
                    key: 'discount',
                    label: 'ส่วนลด',
                    sortable: true
                },
                {
                    key: 'total',
                    label: 'รวม',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'ดำเนินการ',
                    sortable: false
                }
            ],
        }
    },
    created() {

    },
    mounted() {
        this.queryCodInfo()
    },
    methods: {
        queryCodInfo() {
            this.busy = true;
            queryCodInfo({
                pageSize: this.search.pageSize,
                pageIndex: this.search.pageIndex
            }).then(res => {
                console.log(res)
                this.busy = false;
                // this.dataList = res.data.dataList;
                // this.totalItem = res.data.total;
            }).catch(() => {
                this.busy = false;
            })
        },
        changePage(i) {
            if (this.search.pageIndex == i) return;
            this.search.pageIndex = i
            this.queryCodInfo()
        },
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
